import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function CookiesPage() {
  return (
    <>
      <Navbar />
      
      <div className="legal-page">
        <div className="legal-page-header">
          <div className="container">
            <h1 className="legal-title">Politica de Cookies</h1>
            <p className="legal-updated">Ultima actualizare: Ianuarie 2026</p>
          </div>
        </div>

        <div className="legal-content">
              <h2>1. Ce Sunt Cookie-urile?</h2>
          <p>
                Cookie-urile sunt fișiere text mici care sunt plasate pe computerul, tableta sau telefonul tău 
                atunci când vizitezi un website. Ele sunt utilizate pe scară largă pentru a face website-urile să 
                funcționeze mai eficient și pentru a oferi informații operatorilor acestora.
              </p>
          <p>
                Cookie-urile permit website-urilor să:
              </p>
              <ul>
                <li>Să își "amintească" acțiunile și preferințele tale</li>
                <li>Să îmbunătățească experiența de navigare</li>
                <li>Să analizeze performanța website-ului</li>
                <li>Să personalizeze conținutul afișat</li>
              </ul>
          <h2>2. Ce Tipuri de Cookie-uri Folosim?</h2>
              
          <h3>2.1. Cookie-uri Strict Necesare (Esențiale)</h3>
          <p><strong>Scop:</strong> Acestea sunt necesare pentru funcționarea corectă a website-ului.</p>
          <p><strong>Necesită consimțământ:</strong> Nu (sunt strict necesare)</p>
          <p><strong>Exemple:</strong></p>
              <ul>
                <li>Cookie-uri de sesiune pentru autentificare</li>
                <li>Cookie-uri pentru coșul de cumpărături</li>
                <li>Cookie-uri pentru securitate și prevenirea fraudei</li>
                <li>Cookie-uri pentru procesarea plăților</li>
              </ul>
          <p><strong>Durată:</strong> Sesiune (se șterg când închizi browser-ul) sau maximum 24 de ore</p>

          <h3>2.2. Cookie-uri de Performanță (Analytics)</h3>
          <p><strong>Scop:</strong> Ne ajută să înțelegem cum interacționează vizitatorii cu website-ul.</p>
          <p><strong>Necesită consimțământ:</strong> Da</p>
          <p><strong>Exemple:</strong></p>
              <ul>
                <li>Google Analytics - pentru statistici despre trafic și comportament utilizator</li>
                <li>Cookie-uri pentru măsurarea performanței paginilor</li>
                <li>Cookie-uri pentru testarea A/B</li>
              </ul>
          <p><strong>Date colectate (anonime):</strong></p>
              <ul>
                <li>Numărul de vizitatori</li>
                <li>Paginile vizitate</li>
                <li>Timpul petrecut pe site</li>
                <li>Sursa traficului (de unde ai ajuns pe site)</li>
              </ul>
          <p><strong>Durată:</strong> Maximum 2 ani</p>

          <h3>2.3. Cookie-uri de Funcționalitate</h3>
          <p><strong>Scop:</strong> Permit website-ului să își amintească alegerile tale pentru o experiență îmbunătățită.</p>
          <p><strong>Necesită consimțământ:</strong> Da</p>
          <p><strong>Exemple:</strong></p>
              <ul>
                <li>Salvarea preferinței de limbă</li>
                <li>Salvarea preferinței de țară (pentru prețuri în RON/EUR)</li>
                <li>Salvarea setărilor de afișare</li>
              </ul>
          <p><strong>Durată:</strong> Maximum 1 an</p>

          <h3>2.4. Cookie-uri de Marketing (Publicitate)</h3>
          <p><strong>Scop:</strong> Utilizate pentru a afișa reclame relevante pentru tine.</p>
          <p><strong>Necesită consimțământ:</strong> Da</p>
          <p><strong>Furnizori:</strong></p>
              <ul>
                <li>Facebook Pixel - pentru remarketing pe Facebook/Instagram</li>
                <li>Google Ads - pentru remarketing pe Google Display Network</li>
              </ul>
          <p><strong>Durată:</strong> Maximum 90 de zile</p>
          <p>
                <strong>Notă:</strong> Momentan, nu folosim cookie-uri de marketing. Această secțiune va fi actualizată 
                dacă implementăm astfel de tehnologii în viitor.
              </p>
          <h2>3. Cookie-uri Terțe Părți</h2>
          <p>
                Unele cookie-uri sunt plasate de servicii terțe care apar pe paginile noastre:
              </p>
              
          <h3>3.1. Stripe (Procesare Plăți)</h3>
          <p><strong>Furnizor:</strong> Stripe, Inc.</p>
          <p><strong>Scop:</strong> Procesarea securizată a plăților cu cardul</p>
          <p><strong>Date colectate:</strong> Informații despre tranzacție, prevenirea fraudei</p>
          <p><strong>Politica de confidențialitate:</strong> <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a></p>

          <h3>3.2. Google Analytics (opțional, cu consimțământ)</h3>
          <p><strong>Furnizor:</strong> Google LLC</p>
          <p><strong>Scop:</strong> Analiză trafic website</p>
          <p><strong>Date colectate:</strong> Date anonime despre comportamentul utilizatorului</p>
          <p><strong>Politica de confidențialitate:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a></p>
          <h2>4. Cum Gestionezi Cookie-urile?</h2>
              
          <h3>4.1. Banner de Cookie-uri</h3>
          <p>
                La prima vizită pe website-ul nostru, vei vedea un banner care îți permite să:
              </p>
              <ul>
                <li>Accepți toate cookie-urile</li>
                <li>Refuzi cookie-urile opționale</li>
                <li>Personalizezi preferințele (selectezi ce tipuri de cookie-uri accepți)</li>
              </ul>

          <h3>4.2. Modificarea Preferințelor</h3>
          <p>
                Poți modifica oricând preferințele de cookie-uri:
              </p>
              <ul>
                <li>Click pe butonul "Setări Cookie-uri" din footer</li>
                <li>Sau șterge cookie-urile din browser-ul tău (vezi mai jos)</li>
              </ul>

          <h3>4.3. Setările Browser-ului</h3>
          <p>
                Majoritatea browser-elor îți permit să:
              </p>
              <ul>
                <li>Vezi ce cookie-uri sunt stocate și să le ștergi individual sau pe toate</li>
                <li>Blochezi cookie-urile terțe</li>
                <li>Blochezi toate cookie-urile de la anumite website-uri</li>
                <li>Ștergi automat toate cookie-urile când închizi browser-ul</li>
              </ul>

              <h4>Cum gestionezi cookie-urile în diferite browsere:</h4>
              
          <p><strong>Google Chrome:</strong></p>
          <p>Setări → Confidențialitate și securitate → Cookie-uri și alte date ale site-urilor</p>

          <p><strong>Mozilla Firefox:</strong></p>
          <p>Setări → Confidențialitate și securitate → Cookie-uri și date ale site-urilor</p>

          <p><strong>Microsoft Edge:</strong></p>
          <p>Setări → Cookie-uri și permisiuni site-uri</p>

          <p><strong>Safari (Mac):</strong></p>
          <p>Preferințe → Confidențialitate → Gestionare date site-uri web</p>

          <p><strong>Safari (iOS):</strong></p>
          <p>Setări → Safari → Confidențialitate și securitate</p>

          <h3>4.4. Consecințele Dezactivării Cookie-urilor</h3>
          <p>
                <strong>Atenție:</strong> Dacă blochezi sau ștergi cookie-urile esențiale, este posibil ca:
              </p>
              <ul>
                <li>Website-ul să nu funcționeze corect</li>
                <li>Să nu poți finaliza o comandă</li>
                <li>Să pierzi preferințele salvate</li>
                <li>Procesul de plată să eșueze</li>
              </ul>
          <h2>5. Cookie-uri și Dispozitive Mobile</h2>
          <p>
                Pe dispozitivele mobile, cookie-urile funcționează similar ca pe desktop. Însă, există și alți 
                identificatori, cum ar fi:
              </p>
              <ul>
                <li><strong>IDFA (iOS):</strong> Identifier for Advertisers</li>
                <li><strong>AAID (Android):</strong> Google Advertising ID</li>
              </ul>
          <p>
                Poți gestiona acești identificatori din setările dispozitivului tău:
              </p>
              <ul>
                <li><strong>iOS:</strong> Setări → Confidențialitate → Urmărire (Tracking)</li>
                <li><strong>Android:</strong> Setări → Google → Anunțuri</li>
              </ul>
          <h2>6. Web Beacons (Pixel Tags)</h2>
          <p>
                În plus față de cookie-uri, putem folosi și "web beacons" (sau "pixel tags") - imagini transparente 
                mici plasate pe paginile website-ului pentru a măsura eficiența campaniilor de marketing.
              </p>
          <p>
                <strong>Momentan, nu folosim web beacons.</strong> Această secțiune va fi actualizată dacă 
                implementăm astfel de tehnologii.
              </p>
          <h2>7. Local Storage și Session Storage</h2>
          <p>
                Pe lângă cookie-uri, folosim și tehnologii similare cum ar fi:
              </p>
              <ul>
                <li><strong>Local Storage:</strong> Pentru salvarea temporară a datelor (ex: progresul comenzii)</li>
                <li><strong>Session Storage:</strong> Pentru date de sesiune (se șterg când închizi tab-ul)</li>
              </ul>
          <p>
                Aceste tehnologii funcționează similar cu cookie-urile, dar pot stoca mai multe date.
              </p>
          <h2>8. Do Not Track (DNT)</h2>
          <p>
                Unele browsere au o funcție "Do Not Track" care trimite un semnal către website-uri că nu dorești 
                să fii urmărit.
              </p>
          <p>
                <strong>Notă:</strong> Nu există un standard universal pentru DNT, așa că momentan nu răspundem 
                automat la semnalele DNT. Însă, poți oricând să refuzi cookie-urile opționale prin banner-ul nostru.
              </p>
          <h2>9. Actualizări ale Acestei Politici</h2>
          <p>
                Ne rezervăm dreptul de a actualiza periodic această politică pentru a reflecta:
              </p>
              <ul>
                <li>Modificări în funcționalitățile website-ului</li>
                <li>Noi tehnologii implementate</li>
                <li>Schimbări în legislație</li>
                <li>Feedback-ul utilizatorilor</li>
              </ul>
          <p>
                Orice modificare va fi publicată pe această pagină cu data actualizării.
              </p>
          <h2>10. Tabelul Cookie-urilor Utilizate</h2>
              
              <div className="cookie-table">
                <table>
                  <thead>
                    <tr>
                      <th>Nume Cookie</th>
                      <th>Tip</th>
                      <th>Scop</th>
                      <th>Durată</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>session_id</td>
                      <td>Esențial</td>
                      <td>Menține sesiunea utilizatorului</td>
                      <td>Sesiune</td>
                    </tr>
                    <tr>
                      <td>cart_token</td>
                      <td>Esențial</td>
                      <td>Salvează coșul de cumpărături</td>
                      <td>24 ore</td>
                    </tr>
                    <tr>
                      <td>cookie_consent</td>
                      <td>Esențial</td>
                      <td>Salvează preferințele tale de cookie-uri</td>
                      <td>1 an</td>
                    </tr>
                    <tr>
                      <td>country_preference</td>
                      <td>Funcțional</td>
                      <td>Salvează țara selectată (pentru prețuri RON/EUR)</td>
                      <td>30 zile</td>
                    </tr>
                    <tr>
                      <td>_ga, _gid</td>
                      <td>Analytics</td>
                      <td>Google Analytics - analiză trafic</td>
                      <td>2 ani / 24 ore</td>
                    </tr>
                    <tr>
                      <td>_stripe_*</td>
                      <td>Esențial</td>
                      <td>Procesare plăți securizate</td>
                      <td>Sesiune</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <p className="cookie-table-note">
                <strong>Notă:</strong> Lista poate să nu fie exhaustivă și poate fi actualizată periodic.
              </p>
          <h2>11. Mai Multe Informații despre Cookie-uri</h2>
          <p>
                Pentru informații detaliate despre cookie-uri și cum să le gestionezi, poți vizita:
              </p>
              <ul>
                <li><a href="https://www.aboutcookies.org" target="_blank" rel="noopener noreferrer">AboutCookies.org</a></li>
                <li><a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">AllAboutCookies.org</a></li>
                <li><a href="https://ico.org.uk/for-the-public/online/cookies" target="_blank" rel="noopener noreferrer">ICO - Cookie Guide</a></li>
              </ul>
          <h2>12. Contact</h2>
          <p>
                Pentru orice întrebări despre această politică de cookie-uri sau despre modul în care folosim 
                cookie-urile:
              </p>
              <ul>
                <li><strong>Email:</strong> contact@brain-event.com</li>
                <li><strong>Telefon:</strong> +40 767 978 707</li>
                <li><strong>Adresă:</strong> București, România</li>
              </ul>
          <div className="legal-footer">
            <p>
              Folosim cookie-uri pentru a-ți oferi cea mai bună experiență pe website-ul nostru. 
              Mulțumim pentru înțelegere!
            </p>
          </div>
          </div>
        </div>

      <Footer />
    </>
  );
}

export default CookiesPage;

